import React from "react";
import styles from "./styles.css";
import CdpTradeInBannerRevamp from "../cdp-trade-in-banner-revamp/component";
import CarFinanceCdpBannerRevamp from "../car-finance-cdp-banner-revamp/component";
import Cars24PlatinumCoverCdpBannerRevamp from "../cars24-platinum-cover-cdp-banner-revamp/component";
import CarFinancePreApprovedStraightThroughBannerRevamp from "../car-finance-pre-approved-straight-through-banner-revamp/component";
import CarFinancePreApprovedBannerRevamp from "../car-finance-pre-approved-banner-revamp/component";
import PropTypes from "prop-types";
import { CAR_LIST_EVENT_NAMES } from "../../../constants/app-constants";
import { useHistory } from "react-router-dom";
import { trackDesktopCustomEventsAU } from "../../../tracking";
import { EVENT_DATA, EVENT_CONSTANTS } from "./tracking";
import TrackImpression from "../../shared/track-impression";

const CdPFirstFoldBottomBannerRevamp = ({preApproved, setPreApprovedOriginConnect, stEligible, warrantyPlanInfo, onTradeInBannerClick, gaId}) => {
    const history = useHistory();

    const { extendedWarranty = {}} = warrantyPlanInfo || {};

    const plans = extendedWarranty && extendedWarranty.plans || [];

    const handlePreApproval = () => {
        trackDesktopCustomEventsAU(EVENT_CONSTANTS.FINANCE_CARD_CLICKED, EVENT_DATA.FINANCE_CARD_CLICKED);
        setPreApprovedOriginConnect(CAR_LIST_EVENT_NAMES.DETAILS);
        history.push("/financing/get-pre-approval");
    };
    const renderFinanceCard = () => {
        if (preApproved) {
            return (
                <React.Fragment>
                    {stEligible ? <CarFinancePreApprovedStraightThroughBannerRevamp /> : <CarFinancePreApprovedBannerRevamp />}
                </React.Fragment>
            );
        } else {
            return (
                <React.Fragment>
                    <CarFinanceCdpBannerRevamp handlePreApproval={handlePreApproval} />
                </React.Fragment>
            );
        }
    };
    return (
        <div className="container" styleName={"styles.buySellBannerRevamp"}>
            <TrackImpression event={{
                amplitudeName: EVENT_CONSTANTS.TRADE_IN_BANNER_VIEWED,
                properties: {
                    "visitor id": gaId,
                    "source": "cdp"
                },
                gaName: EVENT_CONSTANTS.TRADE_IN_BANNER,
                data: EVENT_DATA.TRADE_IN_BANNER
            }}>
                <div onClick={onTradeInBannerClick}>
                    <CdpTradeInBannerRevamp />
                </div>
            </TrackImpression>
            {renderFinanceCard()}
            <Cars24PlatinumCoverCdpBannerRevamp plans={plans} />
        </div>
    );
};

CdPFirstFoldBottomBannerRevamp.propTypes = {
    preApproved: PropTypes.bool,
    stEligible: PropTypes.object,
    setPreApprovedOriginConnect: PropTypes.func,
    warrantyPlanInfo: PropTypes.object,
    onTradeInBannerClick: PropTypes.func,
    gaId: PropTypes.string
};

export default CdPFirstFoldBottomBannerRevamp;
